var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAncillaryServiceIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 33,
    viewBox: "0 0 28 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0004 18.3333C16.6455 18.3333 18.7899 16.1891 18.7899 13.5438C18.7899 10.8987 16.6455 8.75439 14.0004 8.75439C11.3553 8.75439 9.21094 10.8987 9.21094 13.5438C9.21094 16.1891 11.3553 18.3333 14.0004 18.3333Z",
    stroke: "black",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.36599 10.7716C4.33604 -2.26723 23.6791 -2.25218 26.6341 10.7867C28.3678 18.4353 23.6037 24.9096 19.4275 28.9146C16.3972 31.8355 11.6029 31.8355 8.55744 28.9146C4.39635 24.9096 -0.367799 18.4202 1.36599 10.7716Z",
    stroke: "black",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAncillaryServiceIcon);
export default __webpack_public_path__ + "static/media/Ancillary_service_icon.25c2264b7078eef53a4ea9ca440a19cb.svg";
export { ForwardRef as ReactComponent };